import BaseObject from '../../base/base_object';

export default class LoginErrorHandler extends BaseObject {
    static CLASS = 'LoginErrorHandler';


    init(params) {
        this._serviceFactory = params.serviceFactory;
    }

    _readErrorHandlers(){
        let handlersContext = require.context('./error_handlers/', true, /^.*(_errorhandler)\.js$/);
        return handlersContext.keys().map(handlersContext).map(errorHandlerModule => errorHandlerModule.default.create({
            serviceFactory: this._serviceFactory
        }));

    };

    handleError(errorProcessingResult) {
        let errorHandlers = this._readErrorHandlers();
        errorHandlers.forEach(errorHandler => {
            if(errorHandler.canHandle(errorProcessingResult)) {
                errorHandler.handle(errorProcessingResult);
            }
        });
    }
}